// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-warnign[data-v-34f159a2] {\n  color: #ffa000;\n}\n.proveedor[data-v-34f159a2] {\n  position: relative;\n  top: 0;\n}\n[dir=ltr] .proveedor[data-v-34f159a2] {\n  float: right;\n  right: 0;\n}\n[dir=rtl] .proveedor[data-v-34f159a2] {\n  float: left;\n  left: 0;\n}\n.fecha[data-v-34f159a2] {\n  font-size: 80%;\n  color: #333;\n}\n[dir] .cursor[data-v-34f159a2] {\n  cursor: default;\n}\n", ""]);
// Exports
module.exports = exports;
